"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMENT_MAX_LENGTH = void 0;
exports.COMMENT_MAX_LENGTH = 2000;
//# sourceMappingURL=document-comment.js.map